export default "__VITE_ASSET__05616392__"